import { defineMessages } from '@atlassian/jira-intl';

export const commonMessages = defineMessages({
	avatarPickerModalHeader: {
		id: 'admin-pages-priorities.common.avatar-picker-modal-header',
		defaultMessage: 'Choose icon',
		description: 'Modal header for choosing an icon for a priority',
	},
});
